import styled from "styled-components/macro";

export const StyledDiagnosticTestExamPage = styled.div`
  width: 100%;
`;
